/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取票务订单详情
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  orderId: string,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: order.EsOrderDetailTicketInfo;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/order/ticket-order-detail/${orderId}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
